import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import UserModal from './UserModal';
import { Button } from 'react-bootstrap';

function Users() {
  const [users, setUsers] = useState([]);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [saving, setSaving] = useState(false);

  const fetchUsers = () => {
    setLoading(true);
    api.get('/admin/users')
      .then(res => setUsers(res.data.users || []))
      .catch(() => setError('Failed to load users'))
      .finally(() => setLoading(false));
  };
  const fetchPlans = () => {
    api.get('/plans')
      .then(res => setPlans(res.data.plans || []));
  };

  useEffect(() => {
    fetchUsers();
    fetchPlans();
  }, []);

  const handleEdit = user => {
    setEditingUser(user);
    setShowModal(true);
  };

  const handleCreate = () => {
    setEditingUser(null);
    setShowModal(true);
  };

  const handleDelete = async user => {
    if (!window.confirm(`Delete user "${user.name}"?`)) return;
    setSaving(true);
    try {
      await api.delete(`/admin/users/${user.id}`);
      fetchUsers();
    } catch {
      setError('Failed to delete user');
    } finally {
      setSaving(false);
    }
  };

  const handleSave = async (userData) => {
    setSaving(true);
    try {
      if (editingUser) {
        await api.put(`/admin/users/${editingUser.id}`, userData);
      } else {
        await api.post('/admin/users', userData);
      }
      setShowModal(false);
      fetchUsers();
    } catch {
      setError('Failed to save user');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div>Loading users...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Users & Subscriptions</h2>
        <Button variant="success" onClick={handleCreate}>Create User</Button>
      </div>
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Plan</th>
            <th>Subscription Validity</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u, i) => (
            <tr key={i}>
              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>{u.plan_name || '-'}</td>
              <td>{u.end_date ? new Date(u.end_date).toLocaleDateString() : '-'}</td>
              <td>
                <Button size="sm" variant="primary" className="me-2" onClick={() => handleEdit(u)}>Edit</Button>
                <Button size="sm" variant="danger" disabled={saving} onClick={() => handleDelete(u)}>Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <UserModal show={showModal} onHide={() => setShowModal(false)} onSave={handleSave} user={editingUser} plans={plans} />
    </div>
  );
}

export default Users;
